/*************************************************
 * VirtuOwl
 * localStorage.js
 * Copyright © 2019 concertcare. All rights reserved.
 *************************************************/

let engine = require('store/src/store-engine');
let storetypes = [require('store/storages/localStorage')];

let storeplugins = [require('store/plugins/defaults')];
export default engine.createStore(storetypes, storeplugins);
